import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "0d90b6c8-8ad2-4fb1-b0f8-d219c60482f2",
  publicId: "23",
  name: "Sources summation",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01, task02],
};

export default lesson;
